/* global axios */
import ApiClient from './ApiClient';

class GgSupportHeaderAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId, { signal }) {
    return axios.get(`${this.url}/${conversationId}/gg_support/header`, {
      signal,
    });
  }

  lookup(conversationId, reference, { signal }) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support/lookup_ticket`,
      typeof reference === 'number'
        ? { ticket_id: reference }
        : { ticket_code: reference },
      { signal }
    );
  }

  link(conversationId, ticketIds) {
    return axios.post(`${this.url}/${conversationId}/gg_support/link_tickets`, {
      ticket_ids: ticketIds,
    });
  }
}

export default new GgSupportHeaderAPI();
